<template>
    <div class="modeuleTitle">
           <div class="m-left"><span></span> 添加模块</div>
           <div class="module-img">
            <!-- @click="activeIndex = index" -->
                    <div :class="['bg-img',{'active':index == activeIndex}]" v-for="(item,index) in moImgList" :key="index"   >
                        <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event,index)">
                        <p>{{index == 0 ?'无边框类型':"有边框类型"}}</p>
                     </div>
           </div>
            <div class="m-left" v-show="activeIndex == 1"><span></span> 选择样式</div>
            <div class="cheek-style" v-show="activeIndex == 1">
                <div class="font cheek">
                     <div class="cheek-item">
                        <span>颜色：</span>
                        <el-select v-model="cheekImgValue" placeholder="请选择类型" style="width:100px" @change="cheekImgChange_fn">
                                                <el-option v-for="item in cheekImgSelect"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                        </el-select>
                     </div>
                      <el-upload
                                    action=""
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    accept="image/*"
                                    list-type="picture-card"
                                    :on-change="cheekImg_fn"
                                >
                                
                                     <el-button size="small" type="primary" class="zhuti-img" plain>上传自定义样式</el-button>
                         </el-upload>
                </div>
                <div class="cheek-img">
                     <el-scrollbar style="height:100%;width: 100%;">
                        <div :class="['images',{'images-active':cheekImgIndex == index}]" v-for="(item,index) in cheekImgList" :key="index" @click="cheekImgIndex = index">
                            <img :src="item.url" alt="" draggable="false">
                        </div>
                     </el-scrollbar>

                </div>
            </div>
            <div class="m-left"><span></span> 编辑属性</div>
            <div class="font">
                <span >名称：</span>
                <el-input  v-model="titleName" placeholder="请输入标题名称"  @input="titleName_fn"> </el-input>
                  <el-select v-model="sizeValue" placeholder="请选择大小" style="margin:0px 10px" @change="sizeValue_fn">
                                            <el-option v-for="item in fontSizeList"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                 </el-select>
                 <el-color-picker v-model="titleColor" show-alpha @change="titleColor_fn"></el-color-picker>
            </div>
            <div class="bg-color font" v-show="activeIndex == 0">
                <span>背景：</span>
                <el-color-picker v-model="bgColor" show-alpha ></el-color-picker>
                <span style="margin:0px 12px 0px 20px">渐变</span>
                 <el-checkbox v-model="bgColorChecked" @change='bgColorChecked_fn'></el-checkbox><span class="color1" :style="colorStyle"></span>
            </div>
            <div class="shape font" v-show="activeIndex == 0">
                <span>形状：</span>
                 <el-select v-model="shapeValue" placeholder="请选择形状" style="width:150px" @change="shapeFun">
                                            <el-option v-for="item in shapeList"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                 </el-select>
            </div>
            <div class="icons font ">
                 <div class="icons-left">
                     <span>图标：</span> 

                        <el-select v-model="iconValue" placeholder="请选择类型" style="width:100px;margin-right:10px" @change="iconChange_fn">
                                                    <el-option v-for="item in iconList"  :key="item.value" :label="item.label"  :value="item.value"> </el-option>
                        </el-select>

                            <el-switch v-model="switchValue" active-text="" inactive-text="" @change="switch_fn"></el-switch>
                 </div>
                  <el-upload
                                    action=""
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    accept="image/*"
                                    list-type="picture-card"
                                    :on-change="icon_fn"
                                >
                                     <el-button size="small" type="primary"  plain>上传自定义图标</el-button>
                 </el-upload>
               

            </div>
            <div class="icon-img">
                <!-- nowIconIndex -->
                 <div :class="['icon-item',{'active':nowIconIndex == index}]" v-for="(item,index) in iconImageList" :key="index" @click="nowIconIndex = index">
                    <img :src="item.url" alt="">
                 </div>
            </div>
    </div>
</template>

<script>
export default {
    // props:['nowModulTitleObj'],
      props: {
         nowModulTitleObj: {
            type: Object,
            default: () => ({})
        },
         
        },
  data(){
    return {
        
        moImgList:[
            {
               'url':require('@/assets/customKanBan/moduleWu.png'),
            },
            {
               'url':require('@/assets/customKanBan/moduleYou.png'),
            },
        ],
        activeIndex:0,
        titleName:"",
        sizeValue:"16px",
        titleColor:"#fff",
        bgColor:"#407cdd",
        fontSizeList:[],
        radio: '1',
        //形状数据
        shapeValue:"矩形",
        shapeList:[
            {
                label:"矩形",
                value:"矩形",
            },
            {
                label:"箭形",
                value:"箭形",
            },
            {
                label:"直线",
                value:"直线",
            },
        ],
        //图标数据
        switchValue:true,
        iconValue:"白色",
        iconList:[
            {
                label:"白色",
                value:"白色",
            },
            {
                label:"蓝色",
                value:"蓝色",
            },
            {
                label:"绿色",
                value:"绿色",
            },
            {
                label:"金色",
                value:"金色",
            },
            {
                label:"自定义",
                value:"自定义",
            },
        ],
        iconImageList:[],
        customIconList:[
            {
                'url':require(`@/assets/customKanBan/自定义/ziicon1.png`),
            }
        ],//自定义上传图标
        nowIconIndex:0,
        bgColorChecked:true,//是否开启渐变
        colorStyle:{},
        //样式数据
        cheekImgValue:"蓝色",
        cheekImgSelect:[
           {
                label:"蓝色",
                value:"蓝色",
            },
            {
                label:"绿色",
                value:"绿色",
            },
            {
                label:"金色",
                value:"金色",
            },
            {
                label:"自定义",
                value:"自定义",
            },
        ],
        cheekImgIndex:0,
        cheekImgList:[],
        customCheekList:[
           {
             'url':require(`@/assets/customKanBan/自定义/demo1.png`),
             'url2':require(`@/assets/customKanBan/自定义/demo1.png`)
           }
        ]

    }
  },
  mounted(){
    for(let i = 16 ;i<=20;i++){
           if(i % 2 ==0){
              this.fontSizeList.push({
                label:i,
                value:i+'px'
              })
           }
    }
    for(let i  = 1 ;i <=6 ;i++){
         this.iconImageList.push( {
            'url':require(`@/assets/customKanBan/白色模块/icon${i}.png`)
         })
          this.cheekImgList.push( {
            'url':require(`@/assets/customKanBan/蓝色模块/border${i}.png`),
            'url2':require(`@/assets/customKanBan/蓝色模块/borders${i}.png`)
         })
    }
     
  },
  watch:{
  
    bgColor(val){
        this.colorStyle =  {background: `linear-gradient(to right, ${val}, transparent)`}
        this.$emit('moduleTitleColor_fn',val)
    },
    nowIconIndex(val){
        var d=  {
            'iconValue':this.iconValue,
            'iconImg':this.iconImageList[val].url,
            'iconImgIndex':val,

        }
        this.$emit('nowIcon_fn',d)
    },
      cheekImgIndex(val){
        var d=  {
            'cheekImgType':this.cheekImgValue,
            'cheekImg':this.cheekImgList[val].url2,
            'cheekImgIndex':val,

        }
        this.$emit('nowCheek_fn',d)
    },
    nowModulTitleObj(val){
        this.activeIndex = val.type //有无边框类型
        this.titleName = val.titleStyle.name //标题名称
        this.sizeValue = val.titleStyle.fontSize //字体大小
        this.titleColor = val.titleStyle.color //标题颜色
        this.iconValue = val.iconImgType //图标类型
        //  this.iconImageList_fn( this.iconValue ) // 根据图标类型回显
          this.cheekImgIndex = val.cheekImgIndex
          this.nowIconIndex = val.iconImgIndex
         if(val.type == 1){
             this.cheekImgType = val.cheekImgType //样式类型
            //  this.cheekImgList_fn(this.cheekImgType)
         }
    }

  },
  methods:{


    //拖放
    dragend_fn(e,index){
        var d = { 
            'clientX':e.clientX, 
            'clientY':e.clientY,
            'type':index ,
            'cheekImgType':this.cheekImgValue,
            'cheekImgIndex':this.cheekImgIndex,
            'cheekImg':this.cheekImgList[this.cheekImgIndex].url2,
            'iconImgType':this.iconValue,
            'iconImgIndex':this.nowIconIndex,
            'iconImg':this.iconImageList[this.nowIconIndex].url,
            'iconFlag':this.switchValue,
            'tabIndex':1,
            }
        this.$emit('coordinate_fn',d)
    },
    //背景颜色是否开启渐变
    bgColorChecked_fn(val){
        this.$emit('moduleTitle_fn',val)
    },
    //改变形状
    shapeFun(value){
        this.$emit('shape_fn',value)
    },
    //上传自定义图标
    icon_fn(file){
         var reader = new FileReader();
        reader.readAsDataURL(file.raw); 
        reader.onload = () => {
           this.customIconList.push({'url':reader.result})// 将base64编码的字符串赋值给imageUrl，用于显示上传的图片
        };
        //  this.quanping()
    },
    iconChange_fn(val){
        this.iconImageList_fn(val)
    },
    //图标数据
    iconImageList_fn(val){
        this.iconImageList = []
        var index = this.nowIconIndex
       if(val == '自定义') {
               this.iconImageList  =  this.customIconList
               if(this.nowIconIndex  == this.iconImageList.length){
                  index  = this.iconImageList.length - 1
               }
                var d=  {
                    'iconValue':this.iconValue,
                    'iconImg':this.iconImageList.length == 0 ? "" : this.iconImageList[index].url,
                    'iconImgIndex':this.nowIconIndex,
                }
                this.$emit('nowIcon_fn',d)
         }else {
                for(let i  = 1 ;i <=6 ;i++){
                this.iconImageList.push( {
                    'url':require(`@/assets/customKanBan/${val}模块/icon${i}.png`)
                })
            }
              var d=  {
                    'iconValue':this.iconValue,
                    'iconImg':this.iconImageList[this.nowIconIndex].url,
                    'iconImgIndex':this.nowIconIndex,

                }
                this.$emit('nowIcon_fn',d)
        }

    },
    //图标是否启用
    switch_fn(val){
        this.$emit('iconFlag_fn', val);
    },
    //标题名称
    titleName_fn(val){
        this.titleName = val
        this.titleStyle_fn()
    },
    //标题大小
    sizeValue_fn(val) {
         this.sizeValue = val
         this.titleStyle_fn()
    },
    // 标题颜色
    titleColor_fn(val){
        this.titleColor = val
        this.titleStyle_fn()
    },
    titleStyle_fn(){
        this.$emit('modelTitleName_fn',{
            'name':this.titleName,
            'fontSize':this.sizeValue,
            'color':this.titleColor,
        })
    },
    //样式数据
      cheekImgChange_fn(val){
         this.cheekImgList_fn(val)
    },
    cheekImgList_fn(val){
         this.cheekImgList = []
         var d = {}
          var index = this.cheekImgIndex
     
         if(val == '自定义') {
               this.cheekImgList  =  this.customCheekList
                if(this.cheekImgIndex  == this.cheekImgList.length){
                  index  = this.cheekImgList.length - 1
               }
                d=  {
                    'cheekImgType':"自定义",
                    'cheekImg':this.cheekImgList.length == 0? "" : this.cheekImgList[index].url2,
                    'cheekImgIndex':this.cheekImgIndex,
                }
                console.log("参数",d);
                  this.$emit('nowCheek_fn',d)
         }else {
                for(let i  = 1 ;i <=6 ;i++){
                this.cheekImgList.push( {
                    'url':require(`@/assets/customKanBan/${val}模块/border${i}.png`),
                    'url2':require(`@/assets/customKanBan/${val}模块/borders${i}.png`)
                })
            }
             var d=  {
                'cheekImgType':this.cheekImgValue,
                'cheekImg':this.cheekImgList[this.cheekImgIndex].url2,
                'cheekImgIndex':this.cheekImgIndex,
            }
            console.log("参数",d);
               this.$emit('nowCheek_fn',d)
        }
    },
    cheekImg_fn(file){
         var reader = new FileReader();
        reader.readAsDataURL(file.raw); 
        reader.onload = () => {
           this.customCheekList.push({'url':reader.result,'url2':reader.result}) // 将base64编码的字符串赋值给imageUrl，用于显示上传的图片
        };
        //  this.quanping()
        
    }

  }
}
</script>

<style lang="scss" scoped>
.modeuleTitle {
   .m-left {
    color: #359EFF;
    display: flex;
    align-items: center;
    span {
        background-color: #359EFF;
        display: inline-block;
        width: 2px;
        height: 12px;
        margin-right: 4px;

    }
   }
   .module-img {
     width: 100%;
     height: 150px;
     display: flex;
   justify-content: space-between;
   margin-top: 12px;
   margin-bottom: 20px;
     .bg-img {
        width: 42%;
           background: #fff;
            border-radius: 4px;
            transition: all 0.3s;
            border: 1px solid #F0F0F0;
              padding: 12px;
              &.active {
                // border: 2px solid #0085FF;
                border: 2px solid aqua;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                   box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
        img {
            width: 100%;
            height: 100px;
            margin-bottom: 5px;
        }
     }
     
   }
   .cheek {
    justify-content: space-between;
    margin-bottom: 14px;
   }
   .cheek-img {
    width: 100%;
    height: 240px;
     display: flex;
     flex-wrap: wrap;
     justify-content: space-between;
     .images {
        width: 31%;
        height: 100px;
        background-color: #000000;
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content:center;
        border: 2px solid #f0f0f0;
        transition: all 0.3s;
        &.images-active {
          border-color: #0085FF;
        }
         &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                   box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
        img {
            width: 95%;
            height: 73%;
        }
     }
   }
   .font {
    display: flex;
    align-items: center;
    margin-top: 14px;
    span {
         white-space:nowrap;     
    }
    /deep/.el-checkbox__input {
        line-height: 0px;
    }
   
    .color1 {
        display: inline-block;
        width: 50px;
        height: 18px;
        margin-left: 5px;
        
    }
    .color1 {
        background: linear-gradient(to right, #193157, transparent);
    }
    
   }
   .icons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      .icons-left {
        display: flex;
        align-items: center;
      }
   }
   .icon-img {
    display: flex;
    align-items: center;
    margin-left: 42px;
    margin-top: 12px;
   }
   .icon-item {
    width: 34px;
    height: 34px;
    border-radius: 4px;
    background-color: #191919;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    border: 2px solid transparent;
    &.active {
        border: 2px solid #359EFF;
    }
    img {
        width: 24px;
        height: 24px;
    }
   }

  
}

</style>